import { Toaster as Sonner, ToasterProps } from "sonner";
import React from "react";
import {
  CircleCheckIcon,
  CircleXIcon,
  InfoIcon,
  LoaderIcon,
} from "lucide-react";

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      position="bottom-center"
      icons={{
        success: <CircleCheckIcon className="w-5 h-5" />,
        error: <CircleXIcon className="w-5 h-5" />,
        info: <InfoIcon className="w-5 h-5" />,
        loading: <LoaderIcon className="w-5 h-5" />,
      }}
      style={
        {
          "--width": "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        } as React.CSSProperties
      }
      className="bg-red-500"
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            "text-white min-h-12 rounded-lg grid grid-cols-[auto_1fr_auto_auto] pl-2 overflow-hidden mb-2",
          content: "py-2 pr-4 text-sm flex items-center justify-center",
          icon: "h-full! w-auto! flex items-center justify-center pl-3 pr-3",

          // Buttons
          actionButton:
            "w-12 flex items-center justify-center border-l border-white/20 hover:bg-black/10",
          cancelButton:
            "w-12 flex items-center justify-center border-l border-white/20 hover:bg-black/10",

          // Copy
          title: "leading-6 font-normal",
          description: "leading-6 font-normal",

          success: "bg-system-success text-system-success-foreground",
          error: "bg-destructive text-destructive-foreground",
          info: "bg-secondary-600 text-primary-foreground",
          loading: "bg-primary text-primary-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
